import { SearchRowProfile } from "@wingspanhq/wingspan-api-sdk";

/**
 * The denormalized name-bearing shape shared by the v3 search rows
 * (`PayerRow` / `PayeeRow`): a `profile` plus a top-level `email` fallback.
 */
type SearchRow = {
  profile?: SearchRowProfile;
  email?: string | null;
};

/**
 * Resolves a display name from a v3 search row's denormalized `profile`
 * (`PayerRow` / `PayeeRow`) — the row equivalent of the entity-level
 * `selectorPayerDisplayName` / `selectorPayeeDisplayName`. Prefers the
 * pre-resolved `displayName`, then the individual first/last, then the
 * company name / DBA, and finally the row email. Returns `""` when nothing is
 * available so callers can apply their own placeholder (e.g. `|| "--"`).
 */
export const selectorSearchRowName = (row: SearchRow): string => {
  const p = row.profile;
  const individual = [p?.firstName, p?.lastName].filter(Boolean).join(" ");
  return (
    p?.displayName ||
    individual ||
    p?.companyName ||
    p?.doingBusinessAs ||
    row.email ||
    ""
  );
};
